import {useContext} from "react";
import TranslationContext from "../context/translationContext";

export function useTranslation() : ((key: string) => string) {

    const translations : { [key:string] : string } = useContext(TranslationContext);

    const translate = (key: string) => {
        return translations.hasOwnProperty(key) ? translations[key] : 'MISSING TRANSLATION';
    };

    return translate;
}
